module.exports = __webpack_public_path__ + "static/img/SustainabilityReport_2024_cover_EN.60e5548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SustainabilityReport_2024_cover_EN.jpg
// module id = Yr2X
// module chunks = 1